export default "__VITE_ASSET__lDlE2i9n__"